import type {
  ClientRequest,
  ClientResponse,
  GetListRequestV2,
  GetListResponseOfClientSimpleResponse,
  GetListResponseOfSelectOption,
} from 'src/api/ProactApiClient';
import {clientApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const clientApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getClientSelectOptions: builder.query<
      GetListResponseOfSelectOption,
      GetListRequestV2
    >({
      queryFn: clientQuery(params => clientApiClient.listSelectOptions(params)),
      providesTags: ['Clients'],
    }),
    getClientListV2: builder.query<
      GetListResponseOfClientSimpleResponse,
      GetListRequestV2
    >({
      queryFn: clientQuery(params => clientApiClient.listV2(params)),
      providesTags: ['Clients'],
    }),
    getClient: builder.query<ClientResponse, number>({
      queryFn: clientQuery(id => clientApiClient.get(id)),
      providesTags: ['Clients'],
    }),
    createClient: builder.mutation<ClientResponse, ClientRequest>({
      queryFn: clientQuery(request => clientApiClient.create(request)),
      invalidatesTags: ['Clients'],
    }),
    updateClient: builder.mutation<ClientResponse, ClientRequest>({
      queryFn: clientQuery(request => clientApiClient.update(request)),
      invalidatesTags: ['Clients'],
    }),
    deleteClient: builder.mutation<boolean, number>({
      queryFn: clientQuery(id => clientApiClient.delete(id)),
      // Deleting a client nulls out the clientId association on its sites
      // server-side, so the site list/select-options cache must invalidate too.
      invalidatesTags: ['Clients', 'Sites'],
    }),
    updateClientActiveStatus: builder.mutation<
      ClientResponse,
      {id: number; active: boolean}
    >({
      queryFn: clientQuery(({id, active}) =>
        clientApiClient.updateActiveStatus(id, active)
      ),
      // Active/inactive is a client-only flag; it doesn't touch site
      // associations, so only the Clients cache needs to invalidate.
      invalidatesTags: ['Clients'],
    }),
  }),
});

export const {
  useGetClientSelectOptionsQuery,
  useGetClientListV2Query,
  useGetClientQuery,
  useCreateClientMutation,
  useUpdateClientMutation,
  useDeleteClientMutation,
  useUpdateClientActiveStatusMutation,
} = clientApi;
